export { logoutAndReload }

// Clear the HttpOnly `auth` cookie server-side, then reload so the app re-probes auth and
// lands on <Login>. Best-effort: even if the POST fails (offline), the reload still surfaces
// <Login> via `onLoadDashboard`, so we log and swallow. Two call sites: the explicit "Sign
// out" button (`+Page.tsx`) and the global notLoggedIn-abort recovery (`useTelefuncAbort`).
async function logoutAndReload(): Promise<void> {
  try {
    await fetch('/api/auth/logout', { method: 'POST' })
  } catch (err) {
    // `fetch` rejects only on transport failure (offline/DNS/TLS), never on an HTTP error
    // status (the logout endpoint returns 204 regardless of cookie state) — so this is always
    // an expected client-network blip that the `reload()` below already recovers from, not a
    // bug. Use `console.info` (a breadcrumb): `error`/`warn` are promoted to Sentry issues by
    // `captureConsoleIntegration` (see +client.ts).
    console.info('/api/auth/logout failed:', err)
  }
  location.reload()
}
